import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  RestVendorPurchaseOnOrderListRequest,
  VendorPurchaseOnOrderSearchCriteria,
} from "../../Ds/ds";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import Modal from "../../Components/Modal";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "../../Utils/appConstants";
import ReactTable from "../../Components/Table";
import Image from "../../Components/Base/Image";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";

const OnHandQtyDetails = ({ invLines }) => {
  const tableColumns = [
    {
      header: "SKU",
      accessor: "rollSkuNumber",
      sortable: true,
      // isHyperLink: true,
      // clickHandler: click_Handler,
    },
    {
      header: "YD",
      accessor: "onHandQuantity",
      sortable: true,
      alignment: "right",
    },
    { header: "BIN", accessor: "aisleInfoText", sortable: true },
  ];
  return (
    <div className="model-fw">
      <ReactTable data={invLines} columns={tableColumns} />
    </div>
  );
};

const VendorOnOrderDetails = ({ onOrderLines }) => {
  const tableColumns = [
    {
      header: "PO#",
      accessor: "purchaseOrderNumber",
      sortable: true,
      // isHyperLink: true,
      // clickHandler: click_Handler,
    },
    {
      header: "YD",
      accessor: "onOrderQuantity",
      sortable: true,
      alignment: "right",
    },
    { header: "ETA", accessor: "etaDate", sortable: true },
  ];
  return (
    <div className="model-fw">
      <ReactTable data={onOrderLines} columns={tableColumns} />
    </div>
  );
};

export default function ItemSKUInventoryDetailsInquiry() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [atsInfos, setAtsInfos] = useState([]);
  const [criteria, setCriteria] = useState(
    new SKUBatchInventorySearchCriteria()
  );
  const title = "Item SKU Inventory Details";
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOnHandModelOpen, setIsOnHandModelOpen] = useState(false);
  const [isOnVenOdrModelOpen, setIsOnVenOdrModelOpen] = useState(false);
  const [invLines, setInvLines] = useState([]);
  const [onOrderLines, setOnOrderLines] = useState([]);
  const [isAccessible, setIsAccessible] = useState(false);
  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);

  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };

  const openModal = (type, data) => {
    if (type === 1 && data.onHandQuantity > 0) getInvLines(data);
    if (type === 2 && data.vendorOnOrderQuantity > 0) getOnOrderLines(data);
  };

  const closeModal = () => {
    setIsOnHandModelOpen(false);
    setIsOnVenOdrModelOpen(false);
  };

  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };

  useEffect(() => {
    setFocus();
  }, []);

  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            // const pdfUrl =
            //   `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
            //   reportFilePath;
            // const dynamicName = `document_${Date.now()}.pdf`;
            // const link = document.createElement("a");
            // link.href = pdfUrl;
            // link.download = dynamicName;
            // link.click();
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const generateReport = (type) => {
    const request = new BatchInventorySummaryDataPrintRequest();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode))
        criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    request.criteria = criteria;
    request.reportBean = reportBean;
    const path = "generateItemSkuInventoryDetailsPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };

  const PDFHandler = () => {
    if (SecurityAccessManager.ItemSkuInventoryDetailsPDFReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(1);
    } else {
      setIsAccessible(true);
    }
  };

  const ExcelHandler = () => {
    if (
      SecurityAccessManager.ItemSkuInventoryDetailsInquiryExcelReport_IsAccessible()
    ) {
      setIsLoading(true);
      generateReport(2);
    } else {
      setIsAccessible(true);
    }
  };

  const ResetHandler = () => {
    setCriteria(new SKUBatchInventorySearchCriteria());
    setAtsInfos([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setFocus();
  };

  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.inquiryResult) &&
          !isEmptyArray(response.data.inquiryResult.atsInfos)
        ) {
          setAtsInfos(response.data.inquiryResult.atsInfos);
          if (response.data.inquiryResult.totalCount != null) {
            const total_Count = response.data.inquiryResult.totalCount;
            const maxPage = Math.ceil(total_Count / pageSize);
            setTotalCount(total_Count);
            setIsShowExcel(true);
            setIsShowPdf(true);
            setMaxPage(maxPage);
          }
          if (response.data.inquiryResult.currentPage != null) {
            setPage(response.data.inquiryResult.currentPage);
          }
          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => {
              msg_List.push(info.messageDescription);
            });
            msg = msg_List.toString();
            notify(TOAST_SUCESS, msg);
          }
        }
        if (
          !isEmpty(response.data.inquiryResult) &&
          isEmptyArray(response.data.inquiryResult.atsInfos)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const ExecuteHandler = () => {
    loadPage(1);
  };

  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };

  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };

  const loadFirst = () => {
    loadPage(1);
  };

  const loadLast = () => {
    loadPage(maxPage);
  };

  const loadPage = (id) => {
    if (SecurityAccessManager.ItemSkuInventoryDetailsInquiry_IsAccessible()) {
      setAtsInfos([]);
      setIsLoading(true);
      const request = new RestSkuBatchInventoryListRequest();
      criteria.companyCode = process.env.REACT_APP_COMPANY;
      if (!isEmpty(session)) {
        const { entityCode, code } = session;
        if (!isEmptyString(entityCode))
          criteria.logisticCustomerCode = entityCode;
        if (!isEmptyString(code)) criteria.customerUserCode = code;
      }
      const pageInput = new PageListBean();
      pageInput.currentPage = id;
      pageInput.pageSize = pageSize;
      request.searchCriteria = criteria;
      request.pageInput = pageInput;
      const path = "getItemSkuInventoryDetailsPageList";
      service(token, path, request, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  const enterKeyHandler = (e) => {
    loadFirst();
  };

  const buttonHandler = (e) => {
    loadFirst();
  };

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    setCriteria((prevState) => ({
      ...prevState,
      [name]:
        type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
    }));
  };

  const handleInvLinesResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.skuBatchInventoryPageList) &&
          !isEmptyArray(
            response.data.skuBatchInventoryPageList.skuBatchInventories
          )
        ) {
          setInvLines(
            response.data.skuBatchInventoryPageList.skuBatchInventories
          );
          setIsOnHandModelOpen(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getInvLines = (data) => {
    if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
      setIsLoading(true);
      const request = new RestSkuBatchInventoryListRequest();
      const criteria = new SKUBatchInventorySearchCriteria();
      criteria.companyCode = process.env.REACT_APP_COMPANY;
      criteria.fabricStyleCode = data.fabricStyleCode;
      criteria.colorCode = data.fabricStyleColorCode;
      criteria.isExcludeNonWarehouseInventory = true;
      criteria.fetchQuantityAvailableLinesOnly = true;
      const pageInput = new PageListBean();
      request.searchCriteria = criteria;
      request.pageInput = pageInput;
      const path = "getSkuBatchInventoryPageList";
      service(token, path, request, handleInvLinesResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  const handleOnOrderLinesResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.orderDetailsResult) &&
          !isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)
        ) {
          setOnOrderLines(response.data.orderDetailsResult.onOrderInfoDetails);
          setIsOnVenOdrModelOpen(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getOnOrderLines = (data) => {
    setIsLoading(true);
    const request = new RestVendorPurchaseOnOrderListRequest();
    const criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.fabricStyleCode = data.fabricStyleCode;
    criteria.colorCode = data.fabricStyleColorCode;
    const pageInput = new PageListBean();
    request.searchCriteria = criteria;
    request.pageInput = pageInput;
    const path = "getVendorPurchaseOnOrderDetailsForFabricStyleStatistics";
    service(token, path, request, handleOnOrderLinesResponse, errorCallBack);
  };

  const onClose = () => {
    setIsAccessible(false);
  };
  const openOnHandModal = (val, e, row) => {
    openModal(1, row);
  };
  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, openOnHandModal)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("No Of Rolls", "numberOfRolls", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Earliest ETA", "etaDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Image", "fabricStyleImagePath", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setImageDetails(true)
    );

    return _columns;
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        isOpen={isOnVenOdrModelOpen}
        onClose={closeModal}
        title={"Vendor OnOrder Details"}
      >
        <VendorOnOrderDetails onOrderLines={onOrderLines} />
      </Modal>
      <Modal
        isOpen={isOnHandModelOpen}
        onClose={closeModal}
        title={"OnHand Details"}
      >
        <OnHandQtyDetails invLines={invLines} />
      </Modal>
      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />
      <div className="card-body">
        <div className="row">
          <div className="form-group col-5">
            <InputTextBox
              value={criteria.fabricStyleCodeContains}
              required={true}
              name="fabricStyleCodeContains"
              placeholder={"Enter item code"}
              label={"Item"}
              enterKeyHandler={enterKeyHandler}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
            />
          </div>
          <div className="form-group col-5">
            <InputTextBox
              value={criteria.colorCodeContains}
              required={true}
              name="colorCodeContains"
              placeholder={"Enter color code"}
              enterKeyHandler={enterKeyHandler}
              label={"Color"}
              onChange={onChange}
              disable={disable}
            />
          </div>
          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {!isEmptyArray(atsInfos) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null}
      {!isEmptyArray(atsInfos) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}
      {!isEmptyArray(atsInfos) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>SKU Inventory Details</h1>
          </div>
          <div className="list-wrap">
            {view === 2 ? (
              <>
                <CustomTable
                  columns={Columns}
                  data={atsInfos}
                  isShowFullScreen={true}
                />
              </>
            ) : (
              <>
                {" "}
                {atsInfos.map((ln, idx) => {
                  return (
                    <div className="list-itm" key={idx}>
                      <div className="tb-flex">
                        <div className="table-itm-name">
                          <span className="_imp">{ln.fabricStyleCode}</span>{" "}
                          <span>({ln.fabricStyleName}) </span>
                          <br /> {ln.fabricStyleColorCode}
                        </div>
                        <div className="itm-img-wrap">
                          <Image
                            url={`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_IMAGE_PATH}${ln.fabricStyleImagePath}`}
                            altName={`${ln.fabricStyleCode} - image`}
                          />
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>OnHandQty</div>
                        <div>
                          <span
                            className="hyperLink imp"
                            onClick={() => openModal(1, ln)}
                          >
                            {toCommaSeperatedAmount(ln.onHandQuantity)}
                          </span>
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>NoOfPallets</div>
                        <div className="">{ln.numberOfRolls}</div>
                      </div>
                      <div className="tb-flex">
                        <div>VendorOnOrder</div>
                        <div
                          className="hyperLink imp"
                          onClick={() => openModal(2, ln)}
                        >
                          {toCommaSeperatedAmount(ln.vendorOnOrderQuantity)}
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>Earliest ETA</div>
                        <div className="">{ln.etaDate}</div>
                      </div>
                      <hr />
                    </div>
                  );
                })}{" "}
              </>
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
